











import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import DeliveryForm from '@/components/delivery/DeliveryForm.vue'
import shipmentStore from '@/stores/ShipmentStore'
import Delivery from '@/dto/deliveries/Delivery'
import deliveryStore from '@/stores/DeliveryStore'
import createDeliveryStore, { storageKey } from '@/stores/CreateDeliveryStore'
import { Location } from 'vue-router'
import { Routes } from '@/router/routes'

const labels = {
  on: 'Включена',
  off: 'Отключена',
}
@Component({
  components: { DeliveryForm },
})
export default class DeliveryCreate extends Vue {
  watchers: any = []
  createDeliveryStore = createDeliveryStore
  shipmentStore = shipmentStore
  deliveryStore = deliveryStore

  created() {
    this.createDeliveryStore.setModelFromLocal()

    // Сохраняем в локалсторадж любые изменения формы создания доставки
    const unwatch: Function = this.$watch('model', () => {
      if (this.model) {
        this.localSaveOnChange()
        unwatch()
      }
    })
  }

  get model(): Delivery {
    return this.createDeliveryStore.model as Delivery
  }

  get label(): string {
    return this.model.enabled ? labels.on : labels.off
  }

  get deliveriesRoute(): Location {
    return { name: Routes.deliveries }
  }

  localSaveOnChange() {
    if (this.watchers.length) {
      this.watchers.forEach((unsubscribe: Function) => unsubscribe())
    }
    this.watchers = Object.keys(this.model).map(key => {
      return this.$watch(`model.${key}`, () => {
        localStorage.setItem(storageKey, JSON.stringify(this.model))
      })
    })
  }
}
